import * as React from 'react';
import { Flex } from '../../../../../components/common/flex';
import { IResidenceGroupCardProps } from './residence_group_card.d';

export const ResidenceGroupCard: React.FC<IResidenceGroupCardProps> = ({ residenceGroup }) => {
  return (
    <Flex vertical className={'item-card'}>
      <div className={'item-card__header'}>
        {residenceGroup.residence_array_size > 1 && (
          <div className={'item-card__count'}>{residenceGroup.residence_array_size} ×</div>
        )}
        <div className={'item-card__title'}>{residenceGroup.apartment_name}</div>
      </div>
      <Flex vertical align={'start'} className={'item-row'}>
        <div className={'item-row__title'}>Период проживания</div>
        <Flex vertical gap={2}>
          <div className={'item-row__text'}>{residenceGroup.dates_period}</div>
          <div className={'item-row__text'}>{residenceGroup.nights_count_str}</div>
        </Flex>
      </Flex>
      <Flex vertical align={'start'} className={'item-row'}>
        <div className={'item-row__title'}>Питание</div>
        <div className={`item-row__text${residenceGroup.food_description_present ? ' item-row__text--positive' : ''}`}>
          {residenceGroup.food_description}
        </div>
      </Flex>
      {residenceGroup.residence_array.map((residence, index) => (
        <Flex vertical align={'start'} className={'item-row'} key={index}>
          <div className={'item-row__title'}>
            Размещение {residenceGroup.residence_array_size > 1 && `в ${index + 1} номере`}
          </div>
          <div className={'item-row__text'} dangerouslySetInnerHTML={{ __html: residence.apartment_description }}></div>
          <div className={'item-row__text'} dangerouslySetInnerHTML={{ __html: residence.residence_description }}></div>
        </Flex>
      ))}
      {residenceGroup.conditions_text && (
        <Flex vertical align={'start'} className={'item-row'}>
          <div className={'item-row__title'}>Особое условие</div>
          <div className={'item-row__text'} dangerouslySetInnerHTML={{ __html: residenceGroup.conditions_text }}></div>
        </Flex>
      )}
    </Flex>
  );
};
